import React from 'react';
import { Menu, X } from 'lucide-react';

const BaseLayout = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSubscribe = (e) => {
    e.preventDefault();
    const emailSection = document.querySelector('#email-subscription');
    if (emailSection) {
      emailSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Close mobile menu if open
      setIsMenuOpen(false);
      // Focus the email input after scrolling
      setTimeout(() => {
        const emailInput = emailSection.querySelector('input[type="email"]');
        if (emailInput) {
          emailInput.focus();
        }
      }, 800); // Slightly shorter timeout for better UX
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navigation Bar */}
      <nav className="bg-gradient-to-r from-blue-900 to-purple-900 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            {/* Logo */}
            <div className="flex">
              <div className="flex-shrink-0 flex items-center">
                <a href="/">
                  <img 
                    src="/justlogo192.png" 
                    alt="Proverbs Daily Logo"
                    className="h-10 w-auto" 
                  />
                </a>
              </div>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden sm:flex sm:items-center sm:space-x-4">
              {/* Regular Nav Items */}
              <a 
                href="https://www.youtube.com/@proverbsdaily365" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-yellow-500 text-black px-3 py-2 rounded-md text-sm font-medium hover:bg-yellow-400"
              >
                Daily Blitz
              </a>
              <a href="/" className="text-white hover:text-blue-200 px-3 py-2 rounded-md text-sm font-medium">
                Today's Proverb
              </a>
              <a href="/contact" className="text-white hover:text-blue-200 px-3 py-2 rounded-md text-sm font-medium">
                Contact
              </a>
              
              {/* Action Buttons */}
              <button 
                onClick={scrollToSubscribe}
                className="bg-blue-500 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-600"
              >
                Subscribe
              </button>
              <a 
                href="https://givebutter.com/Pu6n8h"
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-red-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-red-700"
              >
                Donate
              </a>
            </div>

            {/* Mobile Navigation */}
            <div className="flex items-center sm:hidden">
              {/* Always visible action buttons on mobile */}
              <div className="flex items-center space-x-2 mr-2">
                <a 
                  href="https://www.youtube.com/@proverbsdaily365" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-yellow-500 text-black px-3 py-1 rounded-md text-sm font-medium hover:bg-yellow-400"
                >
                  Daily Blitz
                </a>
                <button 
                  onClick={scrollToSubscribe}
                  className="bg-blue-500 text-white px-3 py-1 rounded-md text-sm font-medium hover:bg-blue-600"
                >
                  Subscribe
                </button>
                <a 
                  href="https://givebutter.com/Pu6n8h"
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-red-600 text-white px-3 py-1 rounded-md text-sm font-medium hover:bg-red-700"
                >
                  Donate
                </a>
              </div>
              
              {/* Hamburger Menu Button */}
              <button
                onClick={toggleMenu}
                className="text-white hover:text-blue-200 p-2"
              >
                <span className="sr-only">Open main menu</span>
                {isMenuOpen ? (
                  <X className="block h-6 w-6" />
                ) : (
                  <Menu className="block h-6 w-6" />
                )}
              </button>
            </div>
          </div>

          {/* Mobile Menu Dropdown */}
          {isMenuOpen && (
            <div className="sm:hidden bg-blue-900">
              <div className="px-2 pt-2 pb-3 space-y-1">
                <a
                  href="/"
                  className="text-white hover:text-blue-200 block px-3 py-2 rounded-md text-base font-medium"
                >
                  Today's Proverb
                </a>
                <a
                  href="/contact"
                  className="text-white hover:text-blue-200 block px-3 py-2 rounded-md text-base font-medium"
                >
                  Contact
                </a>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Main content */}
      <main className="w-full">
        <div className="max-w-[1200px] mx-auto px-4">
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-blue-900 to-purple-900 mt-12 w-full">
        <div className="max-w-[1200px] mx-auto px-4 py-8">
          <div className="text-center text-white text-sm">
            © {new Date().getFullYear()} Sacred Studios. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BaseLayout;